// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import orgEntity from './entities/org.json';
import orgMenu from '../pages/org/menu.json';
import orgFullForm from '../pages/org/forms/full.json';
import orgContextForm from '../pages/org/forms/context.json';
import orgMiniForm from '../pages/org/forms/mini.json';
import orgLookupForm from '../pages/org/forms/lookup.json';
import orgTableView from '../pages/org/views/table.json';
import orgStagesView from '../pages/org/views/stages.json';
import orgCardsView from '../pages/org/views/cards.json';
import orgInlineView from '../pages/org/views/inline.json';
import orgBacklogView from '../pages/org/views/backlog.json';
import orgSplitView from '../pages/org/views/split.json';
import orgCalendarView from '../pages/org/views/calendar.json';
import orgDashboardView from '../pages/org/views/dashboard.json';

/** Тип запису «Організація» зі сторінками пакета: меню, форми та подання з pages/org/. */
export const orgDefinition: IRecordTypeDefinition = {
  ...orgEntity,
  views: assembleViewSet({
      table: orgTableView,
      stages: orgStagesView,
      cards: orgCardsView,
      inline: orgInlineView,
      backlog: orgBacklogView,
      split: orgSplitView,
      calendar: orgCalendarView,
      dashboard: orgDashboardView,
  }),
  form: orgFullForm,
  forms: { full: orgFullForm, context: orgContextForm, mini: orgMiniForm, lookup: orgLookupForm },
  menu: orgMenu,
} as IRecordTypeDefinition;
